
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/blog",
      function () {
        return require("private-next-pages/[market]/[language]/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/blog"])
      });
    }
  